import { MapStyle } from '../../../models';
import { createAction, props } from '@ngrx/store';

export const UPDATE_MAP_STYLE = `[Map Style] Update Map Style`;
export const FETCH_MAP_STYLE = `[Map Style] Fetch Map Style`;

export const updateMapStyle = createAction(UPDATE_MAP_STYLE, props<{ mapStyle: MapStyle }>());
export const fetchMapStyle = createAction(FETCH_MAP_STYLE);
